import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EveComponentsModule } from '../../components/eve-components.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DirectivesModule } from '../../directives/directives.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PipesModule } from '../../pipes/pipes.module';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CallRecordingAnalysisPageComponent } from './analysis/call-recording-analysis-page.component';
import { CallRecordingPagesRoutingModule } from './call-recording-pages-routing.module';

@NgModule({
  declarations: [
    CallRecordingAnalysisPageComponent
  ],
  imports: [
    CommonModule,
    CallRecordingPagesRoutingModule,
    EveComponentsModule,
    MatGridListModule,
    MatCardModule,
    FontAwesomeModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    NgxMaterialTimepickerModule,
    DragDropModule,
    DirectivesModule,
    ReactiveFormsModule,
    FormsModule,
    MatPaginatorModule,
    MatStepperModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatExpansionModule,
    MatTabsModule,
    PipesModule,
    
    InputTextModule,
    AutoCompleteModule,
  ]
})
export class CallRecordingPagesModule { }
